var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-inbox",
    "data-name": "Icon awesome-inbox",
    d: "M19.72,10.591,16.05,5.224A1.679,1.679,0,0,0,14.664,4.5H5.336a1.678,1.678,0,0,0-1.387.724L.28,10.591a1.6,1.6,0,0,0-.28.9v4.383A1.646,1.646,0,0,0,1.667,17.5H18.333A1.646,1.646,0,0,0,20,15.875V11.492a1.6,1.6,0,0,0-.28-.9ZM5.634,6.667h8.733L17.329,11H13.056l-1.111,2.167H8.056L6.944,11H2.671L5.634,6.667Z",
    transform: "translate(0 -4.5)",
    fill: "#fbfbfb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox);
export default __webpack_public_path__ + "static/media/inbox.4ba8bcf59d80b86d3bcffd85cd4c1965.svg";
export { ForwardRef as ReactComponent };